import { Button } from '@calizahq/react-components-v2'
import React from 'react'

import blockReasonsMutations from '@/graphql/mutations/blockReasons.mutations'
import { useGraphqlMutation } from '@/hooks/useGraphql'

type DeleteBlockReasonFormProps = {
  handleOnClose: () => void
  handleOnDelete: () => void
  reason: string
  recordId: number
}

export const DeleteBlockReasonForm = ({
  handleOnClose,
  recordId,
  reason,
  handleOnDelete,
}: DeleteBlockReasonFormProps) => {
  const { mutate } = useGraphqlMutation(blockReasonsMutations.deleteBlockReason, {
    onSuccess: () => {
      handleOnDelete()
    },
  })

  const deleteBlockReason = () => {
    mutate({ id: recordId })
  }

  return (
    <div className="flex w-full flex-col">
      <h2 className="mb-4 text-sm text-semantic-black">Are you sure you want to delete below Block Reason?</h2>
      <p className="mb-4 text-p-sm italic icon-tertiary">{reason}</p>
      <div className="flex w-full">
        <Button className=" mr-4 w-full bg-action-secondary" onClick={handleOnClose} size="small" variant="destructive">
          No
        </Button>
        <Button className="w-full bg-text-semantic-success" onClick={deleteBlockReason} size="small">
          Yes
        </Button>
      </div>
    </div>
  )
}
